class roles {
  constructor(rolId, name, description, paStartAsegId) {
    this.rolId = rolId;
    this.name = name;
    this.description = description;
    this.paStartAsegId = paStartAsegId;
  }

  static fromJson({ rolId, nombre, descripcion, paInicioAsegId }) {
    return new roles(rolId, nombre, descripcion, paInicioAsegId);
  }
}

export default roles;
